<template>
  <div class="menu">
    <div class="top">{{ $t("support") }}</div>
    <ul>
      <li
        @click="goPath(index, item)"
        :class="active == index ? 'active' : ''"
        v-for="(item, index) in list"
        :key="index"
      >
        {{ item.name }}
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  data() {
    return {
      list: [
        { path: "/fwzc/onlineClass", name: this.$t("onlineClass") },
        { path: "/fwzc/tecArticles", name: this.$t("tecArticles") },
      ],
    };
  },
  props: {
    mebuActive: "",
    active: null,
  },
  methods: {
    getLocalizedPath(rawPath) {
      const currentLang = this.$i18nState.locale || "zh";
      // 如果路径已经以 /zh 或 /en 结尾，则直接返回
      if (/\/(zh|en)$/.test(rawPath)) {
        return rawPath;
      }
      // 移除路径末尾多余的斜杠，然后添加语言
      const base = rawPath.endsWith("/") ? rawPath.slice(0, -1) : rawPath;
      return `${base}/${currentLang}`;
    },
    goPath(index, item) {
      const fullPath = this.getLocalizedPath(item.path);
      this.$router.replace({ path: fullPath });
      // this.$router.push(item.path);
      document.documentElement.scrollTop = 0;
    },
  },
};
</script>
<style lang="scss" scoped>
.top {
  background: url("../../../assets/img13.png") #1f3b6d;
  height: 80px;
  line-height: 80px;
  text-align: center;
  font-weight: bold;
  font-size: 24px;
  color: #fff;
}

.active {
  background-color: #476da7;
  color: #d1d1d1;
}

.menu {
  width: 250px;
}

ul {
  li {
    width: 250px;
    line-height: 66px;
    border-bottom: 1px solid #cfcfcf;
    background-color: #fff;
    text-align: center;
    font-size: 18px;
    cursor: pointer;
  }

  li:last-child {
    border: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/fwzc/menu/index.vue